import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { pgIconModule } from '@core/pages-ui.module/components/icon/menu-icon.module';
import { KioskInputDirective } from './kiosk-input.directive';
import { KeyboardDirective } from '../utils/keyboard.directive';
import { KeyboardService } from './keyboard.service';
import { KeyboardComponent } from './keyboard.component';
import { KeyboardStyleDirective } from '../utils/keyboard-style.directive';
import { NumericKeyboardComponent } from '../numeric-keyboard/numeric-keyboard.component';

@NgModule({
  declarations: [KeyboardComponent, NumericKeyboardComponent, KioskInputDirective, KeyboardDirective,KeyboardStyleDirective],
  entryComponents: [KeyboardComponent],
  exports: [KeyboardComponent, NumericKeyboardComponent, KeyboardDirective, KioskInputDirective,KeyboardStyleDirective],
  providers: [KeyboardService],
  imports: [
    CommonModule,
    // pgIconModule
  ],
})
export class KeyboardModule {}
